import { Component } from '@angular/core';

@Component({
    selector: 'app-detalhe',
    templateUrl: './detalhe.component.html',
    styleUrl: './detalhe.component.css',
    standalone: false
})
export class DetalheComponent {

}
